"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function extractFilterFromUrl(url, props) {
  url = url.replace('?', '');
  return url.split('&').filter(function (filterString) {
    return !!filterString;
  }).map(function (filterString) {
    var parts = filterString.split('=');
    var foreignKey = "foreign".concat(parts[0].charAt(0).toUpperCase()).concat(parts[0].slice(1));
    var localize = !!props[parts[0]];
    return {
      key: parts[0],
      value: decodeURIComponent(parts[1]),
      foreignKey: foreignKey,
      localize: localize
    };
  });
}

var _default = extractFilterFromUrl;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/footer/extractFilterFromURL.js
// module id = 664
// module chunks = 0